import './css/app.css';
import 'vendor/lazysizes';
import 'framework/klaviyo';
import 'framework/tracking';
import { App } from '@grafikr/components';
import Bugsnag from '@bugsnag/js';

import components from 'framework/components';
import state from 'framework/state';

const app = new App();

components(app);
state(app);
app.mount();

document.addEventListener('app:mount', app.mount);
document.addEventListener('shopify:section:load', app.mount);

Bugsnag.start({
  apiKey: 'ff945d351da2e2102f5fa6bface2efb2',
  enabledReleaseStages: ['production'],
  releaseStage: process.env.NODE_ENV === 'production' ? 'production' : 'development',
  collectUserIp: false,
});
